import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAlert, removeAlert } from './alert-info.action';
import { Alert, AlertTypes } from './alertType';

export const useAlert = () => {
  const alerts = useSelector((state: any) => state.alerts) as Alert[];
  const dispatch = useDispatch();

  const show = useCallback((payload: Alert) => dispatch(setAlert(payload)), [dispatch]);
  const remove = useCallback((payload: number) => dispatch(removeAlert(payload)), [dispatch]);

  return { alerts, show, remove, AlertTypes };
};
